import Vue from 'vue'
import Vuex from 'vuex'
import store from '../store'

Vue.use(Vuex)

const initialState = {
  rules: {
    required: value => (!!value && value.length !== 0) || store.state.langObj.rules.required,
    number: value => !isNaN(value) || store.state.langObj.rules.number,
    email: value => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(value) || store.state.langObj.rules.email
    },
    length: value => value.length >= 6 || 'At least 3 characters'
  }
}

const getters = {
  rules (state) {
    return state.rules
  }
}

export const state = { ...initialState }

export default {
  state,
  getters
}
